module.exports = "<div class=\"row\">\r\n  <div class=\"col-sm-12\">\r\n    <highcharts-chart [Highcharts]=\"FiveYearLineChart\" [options]=\"fiveYearLineChartOptions\"   [(update)]=\"updateFromInput\"></highcharts-chart>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/reports-dashboard/dashboard/report-counts-five-year-card/report-counts-five-year-card.component.html
// module id = ./src/app/admin/reports-dashboard/dashboard/report-counts-five-year-card/report-counts-five-year-card.component.html
// module chunks = main